var App = App || {};

App.NavigationPrimary = (function ($) {
    "use strict";

    var $siteHeaderContainer = $(".site-header-container"),
        $primaryNavigation = $siteHeaderContainer.find(".primary-navigation"),
        $menuContainer = $primaryNavigation.find(".menu-container");

    function init() {
        SetMenuStyle();
        SetMenuSize();

        $(window).on("load orientationchange resize", function () {
            setTimeout(function () {
                SetMenuStyle();
                SetMenuSize();
            }, 1);
        });

        $(document).on("keydown", function (e) {
            if (e.key == "Escape") {
                $primaryNavigation
                    .find(":focus")
                    .trigger("blur");
            }
        });
    }

    function SetMenuStyle() {
        $primaryNavigation.find("ul > li").on("focus focusin mouseover", function (e) {
            var $this = $(this),
                $menuContainer = $this.find(".menu-container");

            if ($menuContainer.hasClass("large-menu")) {
                $siteHeaderContainer.addClass("is-large-menu-open");
            }
        });

        $primaryNavigation.find("ul > li").on("blur focusout mouseout", function (e) {
            $siteHeaderContainer.removeClass("is-large-menu-open");
        });
    }

    function SetMenuSize() {
        $(".primary-navigation .menu-container > div").each(function () {
            var $this = $(this),
                $parent = $this.parent(),
                $megaMenuPages = $this.find(".mega-menu-pages");

            if ($parent.hasClass("large-menu")) {
                $parent.width($siteHeaderContainer.outerWidth());
            }
            else {
                $parent.width($megaMenuPages.outerWidth());
            }

            $parent.height($(this).outerHeight());
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.NavigationPrimary.init();
});